// extracted by mini-css-extract-plugin
module.exports = {"FullFacts":"FullFacts_FullFacts__kzgUh","newline":"FullFacts_newline__Hj3Us"};